import { createSlice } from '@reduxjs/toolkit';
import { TrainingsState } from './TrainingsTypes';
import {
  requestTrainingPlanOperation,
  getLatestTrainingPlanOperation,
  getTrainingPlanStatusOperation,
  fetchExerciseVideoOperation,
} from './trainings-operations';

const initialState: TrainingsState = {
  plan: null, // Заменяем null на мок для разработки
  loadingPlan: false,

  video: null,
  loadingVideo: false,

  error: null,
};
//TODO: потенциально стоит разделить на 2 слайса: один для плана, другой для видео
const trainingsSlice = createSlice({
  name: 'trainings',
  initialState,
  reducers: {
    resetTrainingsState: () => initialState,
    resetVideoState: s => {
      s.video = null;
      s.loadingVideo = false;
      s.error = null;
    },
  },
  extraReducers: builder => {
    /* план */
    builder.addCase(requestTrainingPlanOperation.pending, s => {
      s.loadingPlan = true;
      s.error = null;
    });
    builder.addCase(requestTrainingPlanOperation.fulfilled, (s, { payload }) => {
      s.plan = payload;
      s.loadingPlan = false;
    });
    builder.addCase(requestTrainingPlanOperation.rejected, (s, { payload, error }) => {
      s.loadingPlan = false;
      s.error = payload?.message || error.message || null;
    });

    builder.addCase(getLatestTrainingPlanOperation.pending, s => {
      s.loadingPlan = true;
      s.error = null;
    });
    builder.addCase(getLatestTrainingPlanOperation.fulfilled, (s, { payload }) => {
      s.plan = payload;
      s.loadingPlan = false;
    });
    builder.addCase(getLatestTrainingPlanOperation.rejected, (s, { payload, error }) => {
      if (payload?.status === 409) {
        s.loadingPlan = true;
        s.error = null;
        return;
      }
      s.loadingPlan = false;
      s.error = payload?.message || error.message || null;
    });

    builder.addCase(getTrainingPlanStatusOperation.pending, s => {
      s.loadingPlan = true;
      s.error = null;
    });
    builder.addCase(getTrainingPlanStatusOperation.fulfilled, (s, { payload }) => {
      s.plan = payload;
      s.loadingPlan = false;
    });
    builder.addCase(getTrainingPlanStatusOperation.rejected, (s, { payload, error }) => {
      s.loadingPlan = false;
      s.error = payload?.message || error.message || null;
    });

    /* видео */
    builder.addCase(fetchExerciseVideoOperation.pending, s => {
      s.loadingVideo = true;
      s.error = null;
    });
    builder.addCase(fetchExerciseVideoOperation.fulfilled, (s, { payload }) => {
      s.video = payload;
      s.loadingVideo = false;
    });
    builder.addCase(fetchExerciseVideoOperation.rejected, (s, { payload, error }) => {
      s.loadingVideo = false;
      s.error = payload?.message || error.message || null;
    });
  },
});

export const { resetTrainingsState, resetVideoState } = trainingsSlice.actions;
export default trainingsSlice.reducer;
